<template>
    <div>
        <b-container>
            <!-- <b-modal style="z-index:-1" centered ref="my-modal" id="wrong_fileformat" title="File format wrong!">
                <p class="my-4">
                    Please input reasonable fasta file content!
                    See [About] for more examples
                </p>
            </b-modal> -->
            <h2> Results for {{input_file}}</h2>
            <p class='note_line'>{{ return_msg }}</p>
            <b-table striped hover id="my-table" :items="items" :fields="fields"
                per-page="1" current-page="1">
                <template #cell(download)=row>
                <!-- <template> -->
                    <b-button :disabled="is_disabled" @click="`${downloadfile('results')}`" variant="primary">
                    {{download_string}}
                    </b-button>
                </template>
            </b-table>
            <hr>
            <b-row v-if=is_queue>
                <h3>3D prediction results for {{input_file}}</h3>
                <p> WATING...</p>
                <br>
                <p> Note: This might take hours if you have chosen to use the server to generate the MSA file. </p>
                <p> A specific link has been sent out to your email address, if you have submitted your email address for notification purpose. </p>
                <p> You can also check your job later by searching the unique id: {{unique_id}} </p>
            </b-row>
            <b-row v-if=!is_queue>
<p>
As a preventative measure to resolve any remaining structural clashes and violations, we relax our model predictions through a restrained energy minimization procedure. Specifically, we minimize the AMBER force field with harmonic restraints, which allows the system to remain close to its input structure. The post-prediction relaxation also enforces phosphodiester bond geometry precisely. As measured by RMSD and TM-score, empirical evidence indicates that this final relaxation does not increase the accuracy of the model, but does eliminate distracting stereochemical violations without compromising accuracy.
</p>
<p>
However, the process would be omitted if the pLDDT score, a type of confidence score on the local Distance Difference Test (lDDT-Cα), is too low.
</p>

                <b-col cols="6">
                    <h4> Unrelaxed Model Output </h4>
                    <p> The original output of RhoFold+</p>
                    <div>
                        <iframe :src="viewerIndexUrl"  class="myViewer" ></iframe>
                    </div>
                    <b-button style="margin-top:10px" @click="downloadfile('example_pdb')" variant="primary">Download .pdb</b-button>
                </b-col>
                <b-col cols="6">
                    <h4> Relaxed Model Output (1000 times)  </h4>
                    <p> Normally takes another 2 ~ 10 minutes to compute relaxation results. </p>
                    <div v-if="b_show_relaxed">
                        <iframe v-if="b_show_relaxed" :src="viewerIndexUrl_relaxed"  class="myViewer" ></iframe>
                    </div>
                    <b-button v-if="b_show_relaxed" style="margin-top:10px" @click="downloadfile('relaxed_pdb')" variant="primary">Download .pdb</b-button>
                    <div v-if="!b_show_relaxed && download_string=='Download'" cols="6">
                        <p> Unavailable for this sequence! The pLDDT score (a per-residue confidence score) of original model is too low to compute relaxed model.  </p>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <h4> Sencodary Structure Visualization</h4>
            <b-card v-if="!is_disabled" id='rna' style="height:600px; border:1px solid blue">
                <iframe src="fornacjs/multi-strand.html" ref='iframe_child' frameborder="0" style="width:100%;height:100%;" id="iframeBox"></iframe>
            </b-card>

        </b-container>
    </div>
</template>
<script>
import FileSaver from 'file-saver';
// import ('pdbe-molstar/build/pdbe-molstar-component-1.2.1')

export default {
  data() {
    return {
      is_disabled: true,
      is_queue: true,
      input_file: '',
      requested_no: 0,
      date_id: '',
      items: [],
      download_string: 'waiting...',
      return_msg: '',
      fields: [
        {
          key: 'unique_id',
          label: 'Unique ID',
        },
        {
          key: 'download',
          label: 'Download',
        },
      ],
      resultRNAurl: '',
      viewerIndexUrl: '',
      viewerIndexUrl_relaxed: '',
      b_show_relaxed: false,
    };
  },
  props: {
    filefield: {
      type: String,
      required: true,
    },
  },
  created() {
    const { id } = this.$route.params;
    console.log('id:', id);
    console.log('this.$route.params', this.$route.params);
    this.input_file = this.$route.params.query;
    this.unique_id = this.$route.params.unique_id;
    const blob = new Blob([this.unique_id], { type: 'text/plain;charset=utf-8' });
    if (this.is_disabled) {
      // FileSaver.saveAs(blob,'unique_id.txt');
    }
    this.resultRNAurl = `${this.baseURL}/${this.filefield}?unique_id=${this.unique_id}`;
    this.viewerIndexUrl = `rcsb-viewer/index.html?url=${this.baseURL}/${this.filefield}?unique_id=${this.unique_id}&only_pdb=True`;
    this.viewerIndexUrl_relaxed = `rcsb-viewer/index.html?url=${this.baseURL}/${this.filefield}?unique_id=${this.unique_id}&relaxed=True&only_pdb=True`;
    this.items = [
      {
        // filename: this.input_file,
        unique_id: this.unique_id,
        download: 'Download',
      },
    ];
  },
  mounted() {
    this.start();
    this.twoDstart();
  },
  methods: {
    spin() {
      let viewerInstance;
      let pdbeMolstarComponent = document.getElementById('pdbeMolstarComponentLocal');
      viewerInstance = pdbeMolstarComponent.viewerInstance;
      viewerInstance.visual.toggleSpin(true);
      pdbeMolstarComponent = document.getElementById('pdbeMolstarComponentAlphaFold');
      viewerInstance = pdbeMolstarComponent.viewerInstance;
      viewerInstance.visual.toggleSpin(true);
    },
    sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    async start() {
      await this.get_files_3d(this.unique_id);

      if (this.is_disabled == true && this.requested_no < 20) {
        setTimeout(this.start, 60000);
        this.requested_no++;
      } else if (this.requested_no >= 20 && this.is_disabled == true) {
        // this.$refs['my-modal'].show()
        // this.download_string = "Wrong File";
      }
    },

    async twoDstart() {
      await this.get_files_2d(this.unique_id);
      if (this.is_disabled == true && this.requested_no < 20) {
        setTimeout(this.twoDstart, 60000);
      } else {

      }
    },

    get_files_3d(unique_id) {
      const submit_url = `${this.baseURL}/${this.filefield}`;
      this.axios({
        method: 'get',
        url: submit_url,
        params: {
          // filename: this.input_file,
          unique_id,
          check_success: 'True',
        },
      })
        .then((response) => {
          if (response.data == 'Fail') {
            this.download_string = 'No Such File';
            this.return_msg = 'Input File error. Please try another file.';
          } else if (response.data == 'Queue') {
            this.download_string = 'In Queue';
          } else {
            this.is_queue = false;
            if (response.data == 'Processing') {
              this.download_string = 'Relaxation';
              this.b_show_relaxed = false;
            } else {
              this.is_disabled = false;
              if (response.data == 'Success') {
                this.b_show_relaxed = true;
                this.download_string = 'Download';
              } else if (response.data == 'OnlyOriginal') {
                this.b_show_relaxed = false;
                this.download_string = 'Download';
              } else if (response.data == 'Error') {
                this.download_string = 'Download';
                this.return_msg = 'Errors occured when computing your online task. Please download your result files and see the log.';
              }
            }
          }
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
        });
    },
    get_files_2d(unique_id) {
      const submit_url = `${this.baseURL}/${this.filefield}`;
      this.axios({
        method: 'get',
        url: submit_url,
        params: {
          unique_id,
          only_ct_2d: 'True',
        },
      })
        .then((response) => {
          console.log('response:', response.data);
          this.iframeWin = this.$refs.iframe_child.contentWindow;
          this.iframeWin.postMessage({
            cmd: 'getOptions',
            params: response.data,
          }, '*');
        })
        .catch((error) => {
          /* eslint-disable no-console */
          console.log(error);
        });
    },

    downloadfile(file) {
      if (file == 'results') {
        const finame = `${this.baseURL}/${this.filefield}?unique_id=${this.unique_id}`;
        FileSaver.saveAs(finame, `${this.filefield}_${this.input_file}_results.zip`);
      } else if (file == 'example_pdb') {
        const finame = `${this.baseURL}/${this.filefield}?unique_id=${this.unique_id}&only_pdb=True`;
        FileSaver.saveAs(finame, `${this.filefield}_${this.input_file}_results.pdb`);
      } else if (file == 'relaxed_pdb') {
        const finame = `${this.baseURL}/${this.filefield}?unique_id=${this.unique_id}&relaxed=True&only_pdb=True`;
        FileSaver.saveAs(finame, `${this.filefield}_${this.input_file}_results_relaxed.pdb`);
      }
    },
  },
};
</script>

<style scoped>
.myViewer {
  /* float:left; */
  width:500px;
  height: 500px;
  position:relative;
}
.row {
  padding: 30px;
}
.note_line{
  color: red;
}
</style>
